import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { getSettlementStoreApi } from '~/features/dashboard/api/get-settlement-store.api';

import type { StoreConsoleState } from '~/features/store-console/types/store-console.type';

const initialState: StoreConsoleState = {
  todayRevenue: 0,
  monthlyRevenue: 0,
  lastUpdate: null,
  isLoading: false,
};

export const fetchTodayRevenue = createAsyncThunk(
  'storeConsole/fetchTodayRevenue',
  async (storeId: number) => {
    const today = dayjs().format('YYYY-MM-DD');
    const response = await getSettlementStoreApi({ storeId, startDate: today, endDate: today });
    return response.data.data?.totalRevenue ?? 0;
  },
);

export const fetchMonthlyRevenue = createAsyncThunk(
  'storeConsole/fetchMonthlyRevenue',
  async (storeId: number) => {
    const monthStart = dayjs().startOf('month').format('YYYY-MM-DD');
    const today = dayjs().format('YYYY-MM-DD');
    const response = await getSettlementStoreApi({
      storeId,
      startDate: monthStart,
      endDate: today,
    });
    return response.data.data?.totalRevenue ?? 0;
  },
);

const storeConsoleSlice = createSlice({
  name: 'storeConsole',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTodayRevenue.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchTodayRevenue.fulfilled, (state, action) => {
        state.todayRevenue = action.payload;
        state.lastUpdate = new Date().toISOString();
        state.isLoading = false;
      })
      .addCase(fetchTodayRevenue.rejected, state => {
        state.isLoading = false;
      })
      .addCase(fetchMonthlyRevenue.fulfilled, (state, action) => {
        state.monthlyRevenue = action.payload;
      });
  },
});

export default storeConsoleSlice;
